export const setGeneralData = (data) => ({
    type: 'SET_GENERAL_DATA',
    payload: data,
  });
  